import { render, staticRenderFns } from "./PartnerPage.vue?vue&type=template&id=a62dd37e&scoped=true&"
import script from "./PartnerPage.vue?vue&type=script&lang=js&"
export * from "./PartnerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62dd37e",
  null
  
)

export default component.exports